<tt-grid *ngIf="!!grid" [(ttOptions)]="grid" (ttRowDataChange)="onRowChanged($event)" (ttOnRead)="cdr.markForCheck()" (ttReady)="onGridReady()"></tt-grid>
